import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'

import * as Sentry from '@sentry/react'
import * as TanStackQueryProvider from './integrations/tanstack-query/root-provider.tsx'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

import './styles.css'
import reportWebVitals from './reportWebVitals.ts'
import Watermark from './WaterMark.tsx'

// 声明全局编译时注入的变量
declare const __BUILD_DATE__: string

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    ...TanStackQueryProvider.getContext(),
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

Sentry.init({
  dsn: 'https://a5f67e340e19b1ad948909f6d7e0f6e0@o4509201374117888.ingest.us.sentry.io/4509842785107968',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  // 环境配置
  environment: import.meta.env.MODE,
  // 采样率配置
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  // 集成配置
  integrations: [
    // 浏览器追踪集成
    Sentry.browserTracingIntegration(),
  ],
  // 添加额外的错误信息
  beforeSend(event, hint) {
    // 添加用户信息
    const accessToken = localStorage.getItem('access_token')
    const refreshToken = localStorage.getItem('refresh_token')
    if (accessToken || refreshToken) {
      event.user = {
        id: localStorage.getItem('userId') || 'unknown',
        accessToken,
        refreshToken,
      }
    }

    // 过滤掉一些不需要上报的错误
    if (event.exception) {
      const error = hint.originalException
      if (error instanceof Error) {
        // 过滤网络错误和已知错误
        if (
          error.message.includes('NetworkError') ||
          error.message.includes('Failed to fetch') ||
          error.message.includes('Load failed')
        ) {
          return null
        }
      }
    }

    return event
  },
})

// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  const isProductionDomain = window.location.hostname === 'gk-admin.duyangsong.cn'

  root.render(
    <StrictMode>
      <TanStackQueryProvider.Provider>
        {!isProductionDomain && (
          <Watermark content={`${__BUILD_DATE__}预览版，仅供演示`} />
        )}
        <RouterProvider router={router} />
      </TanStackQueryProvider.Provider>
    </StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
